export const colors = {
  bg: "#F9E9CA",
  headings: "#2F9D6F",
  subhead: "#BB59B1",
  body: "#02051",
  accents: "#0C1D40",
  text: "white",
  black: "white",
  subheading: "#BB59B1",
  green: "#2F9D6F",
  cardsbg: "#0C1D40"
};

export const fonts = {
  titles: "Merriweather",
};

export const mediaQueries = {
  mobile: "@media screen and (max-width: 700px)",
  notMobile: "@media screen and (min-width: 701px)",
  notTablet: "@media screen and (min-width: 901px)",
  tablet: "@media screen and (max-width: 900px)",
};
